<div class="flex justify-between pb-[64px] px-8">
  <div>
    <span class="text-md font-semibold text-purple">In the Know</span>
    <h3 class="text-4xl pt-3 pb-5 font-medium">Latest Beauty Insights</h3>
    <p>Tips to level up your beauty experience.</p>
  </div>
  <button class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">
    View All Posts
  </button>
</div>

<div class="flex justify-between px-8 flex-wrap gap-6">
  <div class="relative w-[384px] group">
    <div class="w-full pb-5 overflow-hidden rounded-2xl">
      <img
        [src]="assetUrl + 'img/insight1.png'"
        class="w-full h-[240px] object-cover rounded-2xl transition-transform duration-500 ease-out group-hover:scale-110"
        alt=""
      />
    </div>
    <h3 class="text-2xl pb-2">Haircare Routine Simplified</h3>
    <p class="text-md">
      Learn how to maintain your salon-fresh hair with expert advice.
    </p>
  </div>

  <div class="relative w-[384px] group">
    <div class="w-full pb-5 overflow-hidden rounded-2xl">
      <img
        [src]="assetUrl + 'img/insight1.png'"
        class="w-full h-[240px] object-cover rounded-2xl transition-transform duration-500 ease-out group-hover:scale-110"
        alt=""
      />
    </div>
    <h3 class="text-2xl pb-2">Haircare Routine Simplified</h3>
    <p class="text-md">
      Learn how to maintain your salon-fresh hair with expert advice.
    </p>
  </div>

  <div class="relative w-[384px] group">
    <div class="w-full pb-5 overflow-hidden rounded-2xl">
      <img
        [src]="assetUrl + 'img/insight1.png'"
        class="w-full h-[240px] object-cover rounded-2xl transition-transform duration-500 ease-out group-hover:scale-110"
        alt=""
      />
    </div>
    <h3 class="text-2xl pb-2">Haircare Routine Simplified</h3>
    <p class="text-md">
      Learn how to maintain your salon-fresh hair with expert advice.
    </p>
  </div>
</div>